<div class="modal-wrapper">
    <div class="modal-header">
        <h2 class="modal-title">
            <i class="las la-bullseye"></i>
            Edit Business Developer Targets — {{ year }}
        </h2>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <p class="text--muted m-b-3">
            Set revenue targets per business developer per month. Use
            <i class="las la-copy"></i> to copy a value to all months for that person.
        </p>

        <div class="table__overflow">
            <table class="table-view table-view--compact target-table">
                <thead>
                    <tr>
                        <th class="month-col">Month</th>
                        <th *ngFor="let businessDeveloper of businessDevelopers" class="division-col text-right">
                            {{ businessDeveloper.businessDeveloperName }}
                        </th>
                        <th class="total-col text-right">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of rows">
                        <td class="month-col">
                            <strong>{{ row.label }}</strong>
                        </td>
                        <td *ngFor="let businessDeveloper of businessDevelopers" class="division-col text-right">
                            <div class="target-input-wrapper">
                                <input
                                    type="number"
                                    step="100"
                                    min="0"
                                    class="target-input"
                                    [ngModel]="row.targets[businessDeveloper.businessDeveloperUuid]"
                                    (ngModelChange)="onValueChanged(row, businessDeveloper.businessDeveloperUuid, $event)"
                                    placeholder="0" />
                                <button
                                    class="copy-btn"
                                    title="Copy to all months"
                                    (click)="copyToAllMonths(businessDeveloper.businessDeveloperUuid, row); $event.stopPropagation()">
                                    <i class="las la-copy"></i>
                                </button>
                            </div>
                        </td>
                        <td class="total-col text-right">
                            <strong>{{ getMonthTotal(row) | number: '1.0-0' }}</strong>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="totals-row">
                        <td><strong>Year Total</strong></td>
                        <td *ngFor="let businessDeveloper of businessDevelopers" class="text-right">
                            <strong>{{ getBusinessDeveloperTotal(businessDeveloper.businessDeveloperUuid) | number: '1.0-0' }}</strong>
                        </td>
                        <td class="text-right">
                            <strong class="text--primary">{{ getGrandTotal() | number: '1.0-0' }}</strong>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>

    <div class="modal-footer">
        <button
            type="button"
            class="button button--primary"
            [disabled]="saving"
            [ngClass]="{ 'button--loading': saving }"
            (click)="save()">
            <i class="las la-save m-r-1"></i> Save targets
        </button>
        <button type="button" class="button button--danger" [disabled]="saving" (click)="clearAll()">
            <i class="las la-eraser m-r-1"></i> Clear all
        </button>
        <button type="button" class="button button--outline" [disabled]="saving" (click)="activeModal.dismiss()">
            Cancel
        </button>
    </div>
</div>
